import { Pie } from "@ant-design/plots";

export default function PieChart({ data = [], colorMapper }) {
  const ddata = [
    {
      type: "分类一",
      value: 270,
    },
    {
      type: "分类二",
      value: 25,
    },
    {
      type: "分类三",
      value: 18,
    },
    {
      type: "分类四",
      value: 15,
    },
    {
      type: "分类五",
      value: 10,
    },
    {
      type: "其他",
      value: 5,
    },
  ];
  const config = {
    appendPadding: 10,
    data: Array.isArray(data) && data.length > 0 ? data : ddata,
    angleField: "value",
    colorField: "type",
    radius: 0.9,
    ...(colorMapper && { color: colorMapper }),
    label: {
      type: "inner",
      offset: "-30%",
      content: ({ percent }) => `${(percent * 100).toFixed(0)}%`,
      style: {
        fontSize: 16,
        textAlign: "center",
      },
    },
    legend: {
      position: "bottom",
      itemName: {
        style: {
          fontSize: 16,
        },
      },
    },
    interactions: [
      {
        type: "element-active",
      },
    ],
  };
  return <Pie {...config} />;
}
